import { GetItineraryImportListItem } from '@orbit/api-types'

/** How long a finished import stays worth a banner. */
export const RECENT_TERMINAL_MS = 30 * 60 * 1000

/**
 * A successful import whose events have all been removed since: the server
 * counts live events only, so nothing is left to review.
 */
export const isClearedImport = (item: GetItineraryImportListItem): boolean =>
	item.status === 'Success' && item.createdEventCount === 0

/**
 * The import the itinerary banner speaks for: a running one first, else the
 * most recently finished one within the window — skipping a cleared success,
 * which has nothing left to review.
 */
export const pickRelevantImport = (
	items: GetItineraryImportListItem[],
	nowMs: number = Date.now(),
): GetItineraryImportListItem | undefined => {
	const sorted = items.slice().sort((a, b) => b.lastUpdatedAt - a.lastUpdatedAt)
	const active = sorted.find(item => item.status === 'Pending' || item.status === 'Processing')
	if (active) return active
	const nowSec = nowMs / 1000
	return sorted.find(
		item => (nowSec - item.lastUpdatedAt) * 1000 < RECENT_TERMINAL_MS && !isClearedImport(item),
	)
}
